export var LIMITS = {};
export var NOTIFICATIONS = ['notifyAllSendersAfterFinalSignature', 'notifyCanceled', 'notifyExpired', 'notifySignerWhenSigned'];
export var REMINDERS = ['none', 'daily', 'every_other_day', 'weekly'];
export default {
  LIMITS: LIMITS,
  REMINDERS: REMINDERS,
  NOTIFICATIONS: NOTIFICATIONS
};